const types = {
  CREATE_REPORT: "CREATE_REPORT",
  DELETE_REPORT: "DELETE_REPORT",
  FETCH_PB_WORKSSPACE_REPORT: "FETCH_PB_WORKSSPACE_REPORT",
  VIEW_REPORT: "VIEW_REPORT",
  VIEW_AAD_REPORT: "VIEW_AAD_REPORT",
  MARK_FAVORITE_UNFAVOURITE: "MARK_FAVORITE_UNFAVOURITE",
  MOVE_REPORT: "MOVE_REPORT",
  MARK_FAVORITE: "MARK_FAVORITE",
  SEARCH_REPORT: "SEARCH_REPORT",
};

export const createReportRequest = `${types.CREATE_REPORT}_REQUEST`;
export const createReportSuccess = `${types.CREATE_REPORT}_SUCCESS`;
export const reportFailure = `${types.CREATE_REPORT}_FAILURE`;

export const viewReportRequest = `${types.VIEW_REPORT}_REQUEST`;
export const viewReportSuccess = `${types.VIEW_REPORT}_SUCCESS`;
export const resetReportDetails = `${types.VIEW_REPORT}_RESET`;

export const viewAadReportSuccess = `${types.VIEW_AAD_REPORT}_SUCCESS`;
export const viewAadReportFailure = `${types.VIEW_AAD_REPORT}_FAILURE`;

export const selectedReportDetails = "selectedReportDetails";

export const fetchPBWorkspaceReportRequest = `${types.FETCH_PB_WORKSSPACE_REPORT}_REQUEST`;
export const fetchPBWorkspaceReportSuccess = `${types.FETCH_PB_WORKSSPACE_REPORT}_SUCCESS`;

export const deleteReportRequest = `${types.DELETE_REPORT}_REQUEST`;
export const deleteReportSuccess = `${types.DELETE_REPORT}_SUCCESS`;

export const markFavUnFavReportRequest = `${types.MARK_FAVORITE_UNFAVOURITE}_REQUEST`;
export const markFavUnFavReportSuccess = `${types.MARK_FAVORITE_UNFAVOURITE}_SUCCESS`;
export const markFavUnFavReportFailure = `${types.MARK_FAVORITE_UNFAVOURITE}_FAILURE`;

export const moveReportRequest = `${types.MOVE_REPORT}_REQUEST`;
export const moveReportSuccess = `${types.MOVE_REPORT}_SUCCESS`;

export const markFavorite = `${types.MARK_FAVORITE}_REQUEST`;
export const markFavoriteFailure = `${types.MARK_FAVORITE}_FAILURE`;

export const searchReportRequest = `${types.SEARCH_REPORT}_REQUEST`;
export const searchReportSuccess = `${types.SEARCH_REPORT}_SUCCESS`;
export const searchReportFailure = `${types.SEARCH_REPORT}_FAILURE`;

export const dispatchCreateReportRequest = () => ({
  type: createReportRequest,
});
export const dispatchCreateReportSuccess = () => ({
  type: createReportSuccess,
});
export const dispatchreportFailure = () => ({
  type: reportFailure,
});

export const dispatchDeleteReportRequest = () => ({
  type: deleteReportRequest,
});
export const dispatchDeleteReportSuccess = () => ({
  type: deleteReportSuccess,
});

export const dispatchFetchPBWorkspaceReportRequest = () => ({
  type: fetchPBWorkspaceReportRequest,
});
export const dispatchFetchPBWorkspaceReportSuccess = (workspaces: any) => ({
  type: fetchPBWorkspaceReportSuccess,
  workspaces,
});
export const dispatchViewReportRequest = () => ({
  type: viewReportRequest,
});
export const dispatchResetReport = () => ({
  type: resetReportDetails,
});
export const dispatchViewReportSuccess = (reportdetails: any) => ({
  type: viewReportSuccess,
  reportdetails,
});
export const dispatchSelectedReport = (selectedReport: any) => ({
  type: selectedReportDetails,
  selectedReport,
});

export const dispatchViewAadReportSuccess = (reportdetails: any) => ({
  type: viewAadReportSuccess,
  reportdetails,
});

export const dispatchMarkFavUnFavReportRequest = () => ({
  type: markFavUnFavReportRequest,
});
export const dispatchMarkFavUnFavReportSuccess = (reports: any) => ({
  type: markFavUnFavReportSuccess,
  reports,
});
export const dispatchMarkFavUnFavReportFailure = () => ({
  type: markFavUnFavReportFailure,
});

export const dispatchViewAadReportFailure = (reportError: any) => ({
  type: viewAadReportFailure,
  reportError,
});
export const dispatchMoveReportRequest = () => ({
  type: moveReportRequest,
});

export const dispatchMoveReportSuccess = () => ({
  type: moveReportSuccess,
});

export const dispatchMarkFavoriteRequest = () => ({
  type: markFavorite,
});
export const dispatchMarkFavoriteFailure = () => ({
  type: markFavoriteFailure,
});

export const dispatchSearchReportRequest = () => ({
  type: searchReportRequest,
});

export const dispatchSearchReportSuccess = (searchReports: any) => ({
  type: searchReportSuccess,
  searchReports,
});

export const dispatchSearchReportFailure = () => ({
  type: searchReportFailure,
});
